import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import FilterListDialog from "../../filterManager/FilterListDialog";
import React from "react";

class StepSelectList extends BaseComponent {

  constructor(props) {
    super(props);
  }

  onChange = (dataRecord) => {
    let listName = '';
    if (dataRecord) {
      listName = dataRecord.listName;
    }
    let query = '';
    if (dataRecord) {
      query = dataRecord.query;
    }
    this.props.data.setMailingListName(listName);
    this.props.data.setQuery(query);
    if (this.props.onRowChanged) {
      this.props.onRowChanged(dataRecord);
    }
  }

  render() {
    let entityName = this.props.entityName.toLowerCase().replace('\\', '/');

    return <FilterListDialog parent={this.props.parent}
                             open={this.props.isFilterListDialogOpen}
                             rows={this.props.filterListRows}
                             data={this.props.filterListData}
                             canClose={false}
                             canEdit={false}
                             displayMode={'inline'}
                             query={null}
                             campaignId={this.props.campaignId}
                             entityName={entityName}
                             onRowChanged={this.onChange}
                             onClose={() => {}}
                             onDone={this.onChange}/>;
  }
}

StepSelectList.propTypes = {
  parent: PropTypes.any.isRequired,
  campaignId: PropTypes.any.isRequired,
  entityName: PropTypes.string.isRequired,
  isFilterListDialogOpen: PropTypes.bool,
  filterListRows: PropTypes.array,
  filterListData: PropTypes.array,
  onRowChanged: PropTypes.func
}

export default StepSelectList;
